/**
 * built-in web client version; must match pom.xml and manifest.mf!
 */
const  BUILTIN_PSAWEBCLI_VER = '8.5.0.20261104054500';
export { BUILTIN_PSAWEBCLI_VER };